<template>
	<svg class="dw-loader" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			opacity="0.15"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
			fill="#64748B"
		/>

		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12C20 7.58172 16.4183 4 12 4Z"
			fill="url(#sp_loader_gradient)"
		/>

		<defs>
			<linearGradient id="sp_loader_gradient" x1="12" y1="12" x2="12" y2="20" gradientUnits="userSpaceOnUse">
				<stop stop-color="currentColor" />
				<stop offset="1" stop-color="currentColor" stop-opacity="0" />
			</linearGradient>
		</defs>
	</svg>
</template>

<style lang="scss" scoped>
.dw-loader {
	animation: spin linear infinite;
    animation-duration: 0.3s;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
	}
    to {
        transform: rotate(360deg);
	}
}
</style>